import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionTime/SectionTime.module.scss';

const cn = classNames.bind(styles);

const SectionTime = (): ReactElement => {
  return (
    <section className={cn('time')}>
      <div className={cn('container')}>

        <h2 className={cn('time__heading')}>
          How Free Time Works in Shipping and Container Storage
        </h2>

        <div className={cn('time__info')}>
          <p className={cn('time__info-paragraph')}>
            Free time is a pivotal element in the world of shipping and logistics, especially when it comes
            to managing demurrage and detention charges. Essentially, free time is the grace period
            granted by a shipping line or terminal operator during which shippers can load or unload their
            containers without incurring demurrage fees or detention charges. The length of this free
            period varies depending on the shipping company, the port, or the terminal, making it essential
            for shippers and consignees to be fully aware of the specific time frames that apply to their
            shipments.
          </p>
          <p className={cn('time__info-paragraph')}>
            To avoid demurrage fees and detention charges, it is vital for shippers to plan ahead and
            coordinate closely with all parties involved in the shipping process, including freight
            forwarders, carriers, and terminal operators. Timely customs clearance is another key factor,
            as customs clearance delays can quickly eat into the free time period and result in unexpected
            costs. Proactive planning, such as scheduling pick-ups and returns in advance
            and <Link className={cn('time__link')} href="/digital-tools/tracking-system">tracking container movements</Link>, can
            help shippers avoid demurrage and detention fees.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionTime;